// extracted by mini-css-extract-plugin
module.exports = {"container":"MemoActionBtn__container--33gSo"};